import Helmet from 'react-helmet'
import React from 'react'
import ReactDOMServer from 'react-dom/server'

const HOST = 'flamingo.shop'
const KNOW_DOMAIN_REG = /((?:m\d?|s|p)\.)?flamingo\.shop/

const fixUrl = link => {
  link = link.replace('www.', '')
  if (/^\/\//.test(link)) {
    return `https:${link}`
  }

  return link
}

const FunkGoHelmet = props => {
  let jsonLD

  if (Array.isArray(props.jsonLD)) {
    jsonLD = props.jsonLD
  } else if (typeof props.jsonLD === 'object') {
    jsonLD = [props.jsonLD]
  }

  const pageUrl = fixUrl(props.url).replace(KNOW_DOMAIN_REG, HOST)
  const imageUrl = fixUrl(props.image)

  const allowShare = props.private !== true
  const disableIndex = props.private === true || props.noIndex === true

  return (
    <Helmet>
      <title>{props.seoTitle || props.title}</title>
      <meta name="description" content={props.description} />
      <link rel="canonical" href={pageUrl} />

      { props.fbAppId && <meta property='fb:app_id' content={props.fbAppId} /> }
      { allowShare && <meta property='og:type' content='website' /> }
      { allowShare && <meta property='og:url' content={pageUrl} /> }
      { allowShare && <meta property='og:title' content={props.title} /> }
      { allowShare && <meta property='og:description' content={props.description} /> }
      { allowShare && <meta property='og:image' content={imageUrl} /> }
      { allowShare && <meta property='og:site_name' content={props.siteName} /> }
      { allowShare && <meta property='twitter:card' content='summary_large_image' /> }
      { disableIndex && <meta name='robots' content='noindex' />}

      {
        jsonLD && jsonLD.map((data, i) => (
          <script key={i} type='application/ld+json'>{JSON.stringify(data)}</script>
        ))
      }
    </Helmet>
  )
}

// use on server side
const renderHelmetString = props => {
  ReactDOMServer.renderToString(<FunkGoHelmet {...props} />)
  const helmet = Helmet.renderStatic();
  return helmet.title.toString()
    + helmet.meta.toString()
    + helmet.link.toString()
    + helmet.script.toString()
}

FunkGoHelmet.renderToString = renderHelmetString

export {
  renderHelmetString
}

export default FunkGoHelmet